'use strict';

var React = require('react');

var SvgBuyButtonVerticalLayoutMajor = function SvgBuyButtonVerticalLayoutMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3 3h1v-2h-1.5a1.5 1.5 0 0 0-1.5 1.5v1.5h2v-1zm14 0v1h2v-1.5a1.5 1.5 0 0 0-1.5-1.5h-1.5v2h1zm-14 13v1h1v2h-1.5a1.5 1.5 0 0 1-1.5-1.5v-1.5h2zm14 1h-1v2h1.5a1.5 1.5 0 0 0 1.5-1.5v-1.5h-2v1zm-16-11v3h2v-3h-2zm0 8v-3h2v3h-2zm16-8v3h2v-3h-2zm0 8v-3h2v3h-2zm-3-5v-6h-8v6h8zm-2 8h-6v-2h6v2zm-6-4h8v-2h-8v2z"
  }));
};

exports.SvgBuyButtonVerticalLayoutMajor = SvgBuyButtonVerticalLayoutMajor;
